import { createTranslationsActions } from '@wf/modux'
// Setup core translation actions for Modux
const translationActions = createTranslationsActions({
    contextCode: 'TEMPLATE-UI',
    contextPath: '/api',
    resourcePath: '/translations'
})

export { translationActions }
